const GET_ACTIVE_ASSET_EXCEL_DATA = 'GET_ACTIVE_ASSET_EXCEL_DATA'
const SET_ACTIVE_ASSET_EXCEL_DATA = 'SET_ACTIVE_ASSET_EXCEL_DATA'

const SET_ACTIVE_ASSET_GRID_FILTERS = 'SET_ACTIVE_ASSET_GRID_FILTERS'

const GET_ACTIVE_ASSET_GRID_DATA = 'GET_ACTIVE_ASSET_GRID_DATA'
const SET_ACTIVE_ASSET_GRID_DATA = 'SET_ACTIVE_ASSET_GRID_DATA'

const SET_IS_GRID_DATA_LOADING = 'SET_IS_GRID_DATA_LOADING'

export {
    GET_ACTIVE_ASSET_EXCEL_DATA,
    SET_ACTIVE_ASSET_EXCEL_DATA,
    SET_ACTIVE_ASSET_GRID_FILTERS,
    GET_ACTIVE_ASSET_GRID_DATA,
    SET_ACTIVE_ASSET_GRID_DATA,
    SET_IS_GRID_DATA_LOADING
}